<template>
	<sf-data-table
		ref="partPopupTable"
		:pageUnit="pageUnit_"
		:totalSize="totalSize_"
		paging
		:columns="columns"
		:rows="resultPopupList"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
		height="520px"
		fit="fit"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	async created() {
		// console.clear();
		this.screen = this.screenArray.get(this.scrId);
		//들어오자마자 state 초기화 하는 방법
		//this.setSearchPopupCommInit_();
		await this.getCommCodes_({ key: 'pgsStPcList', codeType: 'PGS_ST_PC' }); //검사상태;
		// this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					// 품번
					label: this.getMessage_('QWCC000956'),
					prop: 'partNo',
					minWidth: '110px',
					clickEvent: this.scrNameClick,
					sortable: false,
					highlight: true
				},
				{
					// 품명
					label: this.getMessage_('QWCC000957'),
					prop: 'partNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					// 검사번호
					label: this.getMessage_('QWCC000005'),
					prop: 'ckuNo',
					minWidth: '140px',
					sortable: false
				},
				{
					// 검사구분
					label: this.getMessage_('QWCC000987'),
					prop: 'ckuScnCd',
					minWidth: '80px',
					sortable: false,
					form: {
						type: 'select',
						options: this.getCkuScnCdList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC000009'), //검사원Id
					prop: 'ckurId',
					minWidth: '1px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000009'), //검사원명
					prop: 'ckurNm',
					minWidth: '70px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000070'), //검사일자
					prop: 'ckuDd',
					minWidth: '100px',
					sortable: true
				},
				{
					// lot시작번호
					label: 'LOT FROM',
					prop: 'lotFromNo',
					minWidth: '100px',
					sortable: false,
					highlight: false
				},
				{
					// lot종료번호
					label: 'LOT TO',
					prop: 'lotToNo',
					minWidth: '100px',
					sortable: false,
					highlight: false
				},
				{
					//부품상태(종합판정)
					label: this.getMessage_('QWCC001271'),
					prop: 'ovrlJgmtCd',
					minWidth: '90px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getOvrlJgmtCdList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					//진행상태
					label: this.getMessage_('QWCC001219'),
					prop: 'pgsStCd',
					minWidth: '80px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getPgsStPcCdList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload');
		},
		scrNameClick(row) {
			//this.editRow = row;
			this.$emit('SendData', row);
		}
	}
};
</script>

<style></style>
